import { render, staticRenderFns } from "./OrdersTransactions.vue?vue&type=template&id=f2212080"
import script from "./OrdersTransactions.vue?vue&type=script&lang=js"
export * from "./OrdersTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports